import { downloadFilePost, post } from 'utils/api';
import { DataResponse } from './response';


export interface ProductionPlanningReport {
  /// Số thứ tự 1
  stt?: number;
  /// Khách hàng 2
  khachHang: string;
  /// Tên TP/BTP 3
  tenTPBTP: string;
  /// Mã TP/BTP 4
  maTPBTP: string;
  // kích thước sp
  kichThuocSanPham: string;
  // nhóm sp
  nhomSanPham: string;
  /// Sản phẩm (tái bản/ lần đầu)
  sanPhamTBLD: string;
  /// Số WO
  soWO: string;
  /// Ngày ban hành WO
  ngayBanHanhWO: string;
  /// Trạng thái WO
  trangThaiWO: string;
  /// Ngày y/c giao hàng theo SO
  ngayYeuCauGiaoHangTheoSO: string;
  /// Ngày yêu cầu nhập kho
  ngayYeuCauNhapKho: string;

  // số lượng cần sản xuất sp
  soLuongCanSanXuatSanPham: string;
  // số lượng cần sản xuất tờ
  soLuongCanSanXuatTo: string;

  /// Số lượng WO
  soLuongWO?: number;
  /// S.lượng cần sản xuất
  soLuongCanSX?: number;
  /// Số sản phẩm/1 tờ/ 1 CĐ
  soSanPham1To1CD?: number;
  /// S.lượng cần sản xuất
  soLuongCanSanXuat?: number;
  /// Loại NVL
  loaiNVL: string;
  /// Khổ NVL
  khoNVL: string;
  /// Quy cách IN
  quyCachIn: string;
  /// Thông số màu
  thongSoMau: string;
  /// Mã màu pha
  maMauPha: string;
  /// Công đoạn sản xuất
  congDoanSanXuat: string;
  /// Máy chuyền sản xuất
  mayChuyenSanXuat: string;
  // thời gian bắt đầu sản xuất kế hoạch
  thoiGianBatDauSanXuatKeHoach: string;
  thoiGianKetThucSanXuatKeHoach: string;
  thoiGianBatDauSanXuatThucTe: string;
  thoiGianKetThucSanXuatThucTe: string;

  /// Thời gian bắt đầu sản xuất
  ngayBatDauSanXuatKeHoach: string;
  /// Thời gian kết thúc
  ngayKetThucKeHoach: string;
  /// TG bắt đầu sản xuất (ghi nhận thực tế)
  ngayBatDauSanXuatThucTe: string;
  /// TG kết thúc (ghi nhận thực tế)
  ngayKetThucSanXuatThucTe: string;
  /// TG định mức chuẩn bị (phút)
  tgDinhMucChuanBi?: number
  /// Thời định mức gian canh máy (phút)
  tgDinhMucCanhMay?: number
  /// Thời định mức gian sản xuất
  tgDinhMucSanXuat?: number
  /// Tổng định mức TG SXCĐ (phút)
  tongThoiDinhMucGianSanXuatCongDoan?: number
  /// TG thực tế chuẩn bị (phút)
  tgThucTeChuanBi?: number
  /// Thời gian thực tế canh máy (phút)
  tgThucTeCanhMay?: number
  /// Thời gian thực tế sản xuất
  tgThucTeSanXuat?: number
  /// Tổng TG thực tế SXCĐ (phút)
  tongThoiThucTeGianSanXuatCongDoan?: number
  // chênh lệch
  chenhLech: number

  thoiGianBatDauCanhMay: string,
  thoiGianKetThucCanhMay: string,

  equipments: [];
  isYellow: boolean;
}

export interface IProductionPlanningServices {
  getListReport(data: any): Promise<DataResponse<ProductionPlanningReport[]>>;
  exportExcel(data: object): Promise<void>;
}

export function createProductionPlanningServices(): IProductionPlanningServices {
  return {
    getListReport: async (data: any) => {
      return (await post(`BC/get-data-bckhsx`, data)).data;
    },
    exportExcel: async (data: object) => {
      await downloadFilePost(`BC/export-excel-bckhsx`, data);
    },
  };

}
